<template>
  <div class="flex w-full flex-col justify-center rounded-lg p-16 py-32 text-center">
    <div>
      <PhotographIcon class="text-neutral-95 mx-auto h-14 w-14 stroke-2" />
      <span class="text-neutral-90 mt-2 block text-base font-normal">{{ t("noTemplatesFoundTitle") }}</span>
      <span class="text-neutral-90 mt-1 block text-sm font-normal">{{ t("noTemplatesFoundDescription") }}</span>
    </div>
  </div>
</template>

<script lang="ts" setup>
//Icons
import { PhotographIcon } from "@heroicons/vue/outline";

//Utils
import { useI18n } from "vue-i18n";

const { t } = useI18n();
</script>

<i18n lang="jsonc">
{
  "es": {
    "noTemplatesFoundTitle": "Crea una nueva campaña para comenzar",
    "noTemplatesFoundDescription": "Aquí verás todas las plantillas de tus campañas",
  },
  "pt": {
    "noTemplatesFoundTitle": "Crie uma nova campanha para começar",
    "noTemplatesFoundDescription": "Aqui você verá todos os templates de suas campanhas",
  },
}
</i18n>
